import { render, staticRenderFns } from "./SideBarLoading.vue?vue&type=template&id=2c897dd2&scoped=true"
import script from "./SideBarLoading.vue?vue&type=script&lang=js"
export * from "./SideBarLoading.vue?vue&type=script&lang=js"
import style0 from "./SideBarLoading.vue?vue&type=style&index=0&id=2c897dd2&prod&scoped=true&lang=scss"
import style1 from "./SideBarLoading.vue?vue&type=style&index=1&id=2c897dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c897dd2",
  null
  
)

export default component.exports